import { useEffect } from "react";
import Typewriter from "typewriter-effect";

const SHOP_URL = process.env.REACT_APP_SHOP_URL ?? "/shop";

function App() {
  const params = new URLSearchParams(window.location.search);
  const redirectProfile = params.get("redirect_profile") ?? "";
  const tokenFromUrl = params.get("token") ?? "";

  useEffect(() => {
    if (!tokenFromUrl) return;
    localStorage.setItem("token", tokenFromUrl);
    // Remove o token da URL e fica no site
    const params = new URLSearchParams(window.location.search);
    params.delete("token");
    const newQuery = params.toString();
    window.history.replaceState({}, "", window.location.pathname + (newQuery ? `?${newQuery}` : ""));
  }, []);

  const shopUrl = redirectProfile
    ? `${SHOP_URL}?redirect_profile=${redirectProfile}`
    : SHOP_URL;

  return (
    <div className="flex flex-col">
      {/* Hero */}
      <div className="flex flex-col items-center justify-center w-screen h-screen bg-[#fdda00]">
        <img src="./logo.png" className="App-logo" alt="bee.zen" />
        <h1 className="flex font font-comfortaa text-3xl">
          <span className="mr-2">gerenciamento de </span>
          <Typewriter
            options={{
              strings: [
                "times",
                "escolas",
                "cursos",
                "equipes",
                "intranet",
                "faculdades",
                "ead corporativo",
              ],
              autoStart: true,
              loop: true,
            }}
          />
        </h1>
        <a href="#assinar" className="mt-10 animate-bounce text-sm font-semibold text-gray-700 flex flex-col items-center gap-1">
          <span>Ver planos</span>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </a>
      </div>

      {/* Seção de assinatura */}
      <section id="assinar" className="flex flex-col items-center justify-center min-h-screen bg-white px-6 py-20">
        <h2 className="text-3xl font-bold text-gray-800 mb-2 text-center">Comece agora</h2>
        <p className="text-gray-500 mb-12 text-center">Assine e tenha acesso a todos os benefícios da plataforma.</p>

        <div className="w-full max-w-sm rounded-2xl border-2 border-[#fdda00] shadow-lg p-8 flex flex-col items-center gap-6">
          <div className="flex flex-col items-center">
            <span className="text-sm font-semibold uppercase tracking-widest text-gray-400">Plano mensal</span>
            <span className="text-5xl font-extrabold text-gray-800 mt-2">Bee Benefícios</span>
          </div>

          <ul className="text-gray-600 text-sm space-y-2 w-full">
            <li className="flex items-center gap-2">
              <span className="text-[#fdda00] font-bold">✓</span> Acesso completo à rede de benefícios
            </li>
            <li className="flex items-center gap-2">
              <span className="text-[#fdda00] font-bold">✓</span> Cancele quando quiser
            </li>
            <li className="flex items-center gap-2">
              <span className="text-[#fdda00] font-bold">✓</span> Suporte dedicado
            </li>
          </ul>

          <a
            href={shopUrl}
            className="w-full text-center bg-[#fdda00] hover:bg-yellow-400 transition-colors text-gray-900 font-bold py-3 px-6 rounded-xl text-lg"
          >
            Assinar
          </a>
        </div>
      </section>
    </div>
  );
}

export default App;
